import { useState, useEffect } from "react"
import React from "react"
import { Box, Select, MenuItem, FormControl, InputLabel, Grid, Switch, Button, TextField, InputAdornment, Paper } from "@mui/material"
import API, { URL_PATH } from "../../services/API"
import Text from "../../components/Text"
import Toast from "../../components/Toast"
import Header from "../../components/Header"
import SearchIcon from "@mui/icons-material/Search"

const moment = require("moment")

function TimingScreen() {
  const [timeZone, setTimeZone] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [activeHours, setActiveHours] = React.useState([])
  const [availableTimeZones, setAvailableTimeZones] = React.useState([])
  const [searchQuery, setSearchQuery] = React.useState("")
  const [dropdownOpen, setDropdownOpen] = React.useState(false)
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success" 
  })
  
  React.useEffect(() => {
    getData()
    getTimeData() // Initial load without search query
  }, [])

  const getData = async () => {
    const response = await API(this, "get", URL_PATH.GET_PREFERENCES)
    const { status, message, data } = response

    const { hotelConfig, activeHours, timezones } = data

    if (status == "success") {
      setActiveHours(activeHours)
      setLoading(false)
    }
  }

  const getTimeData = async (query = "") => {
    try {
      const response = await API(this, "get", URL_PATH.GET_TIMEZONES(query))
      const { status, data } = response

      if (status === "success" && Array.isArray(data)) {
        setAvailableTimeZones(data)
      } else {
        console.error("Invalid timezone response", response)
        setAvailableTimeZones([])
      }
    } catch (error) {
      console.error("Error fetching timezones:", error)
      setAvailableTimeZones([])
    }
  }

  const handleSearchChange = (e) => {
    const query = e.target.value
    setSearchQuery(query)
    getTimeData(query)
  }

  const timeIntervals = [
    "09:00 AM",
    "09:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "01:00 PM",
    "01:30 PM",
    "02:00 PM",
    "02:30 PM",
    "03:00 PM",
    "03:30 PM",
    "04:00 PM",
    "04:30 PM",
    "05:00 PM",
    "05:30 PM",
    "06:00 PM",
    "06:30 PM",
    "07:00 PM",
    "07:30 PM",
    "08:00 PM",
    "08:30 PM",
    "09:00 PM",
    "09:30 PM",
    "10:00 PM",
    "10:30 PM",
    "11:00 PM",
    "11:30 PM",
  ]

  const handleOpenTimeChange = (index, event) => {
    setActiveHours((prev) => {
      const newActiveHours = [...prev]
      const twhrs = moment(event.target.value, "hh:mm A").format("HH:mm:ss")
      newActiveHours[index].start_time = twhrs
      return newActiveHours
    })
  }

  const handleCloseTimeChange = (index, event) => {
    setActiveHours((prev) => {
      const newActiveHours = [...prev]
      const twhrs = moment(event.target.value, "hh:mm A").format("HH:mm:ss")
      newActiveHours[index].end_time = twhrs
      return newActiveHours
    })
  }

  const handleToggleCloseDay = (index) => {
    setActiveHours((prev) => {
      const newActiveHours = [...prev];
      newActiveHours[index].status = newActiveHours[index].status === 1 ? 0 : 1;
      return newActiveHours;
    });
  };
  

  const compareTimes = (time1, time2) => {
    // For debugging
    console.log(`Comparing: ${time1} vs ${time2}`);
    
    // Convert both times to moment objects for accurate comparison
    const t1 = moment(time1, "hh:mm A");
    const t2 = moment(time2, "hh:mm A");
    
    // Return true if time1 is equal to or later than time2
    return t1.isSameOrAfter(t2);
  };

  const convert24to12 = (time24 = null) => {
    if (!time24) return "";
    // Use 'hh' to ensure leading zero for hours
    return moment(time24, "HH:mm:ss").format("hh:mm A");
  };
  

  const saveConfig = async () => {
    const fd = {
      timezone: timeZone,
      activeHours: activeHours,
    }

    const { status, message, data } = await API(this, "post", URL_PATH.saveConfig, fd)

    if (status == "success") {
      setToast({
        open: true,
        message: message,
        severity: "success"
      })
    } else {
      setToast({
        open: true,
        message: message || "An error occurred",
        severity: "error"
      })
    }
  }

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setToast(prev => ({ ...prev, open: false }))
  }

  const handleTimeZone = (event) => {
    setTimeZone(event.target.value)
    setDropdownOpen(false)
  }

  const selectStyles = {
    backgroundColor: "#02111B",
    focus: "none",
    color: "white",
    "& .MuiSelect-icon": {
      color: "white",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "none",
    },
  }

  const menuProps = {
    PaperProps: {
      sx: {
        backgroundImage: "none",
        backgroundColor: "#02111B",
        color: "white",
        "& .MuiMenuItem-root": {
          "&:hover": {
            backgroundColor: "#041A29",
          },
          "&.Mui-selected": {
            backgroundColor: "#041A29",
            "&:hover": {
              backgroundColor: "#041A29",
            },
          },
        },
        "&::-webkit-scrollbar": {
          display: "none",
        },
        scrollbarWidth: "none",
        "-ms-overflow-style": "none",
        maxHeight: "250px",
      },
    },
  }
  
  if (loading) return <Box>
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          padding: 15,
          alignSelf: "center",
          borderRadius: "50%",
        }}
      >
        <img
          src={"/Etable Loading.gif"}
          style={{
            width: 180,
            height: 180,
          }}
          className="fade-in"
        />
      </div>
    </div>
  </Box>

  return (
    <>
                        <Header title="Restro Timing" />

    <Box
      sx={{
        margin: "0px auto",
        padding: "30px",
        backgroundColor: "#02111B",
        border: "1px solid #FFC857",
        maxWidth: "1000px",
        borderRadius: "8px",
        overflowX: "auto",
      }}
    >
      
      <Grid container alignItems="center" sx={{ mb: 2, px: 1 }}>
        <Grid item xs={2}>
          <Text h8 medium></Text>
        </Grid>
        <Grid item xs={3}>
          <Text h8 medium>
            Open Time
          </Text>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3}>
          <Text h8 medium>
            Close Time
          </Text>
        </Grid>
        <Grid item xs={3}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text h8 medium>
              Closed Day
            </Text>
          </Box>
        </Grid>
      </Grid>

      {activeHours.map((item, index) => {
  // Console log for end_time and converted value
  console.log('Day:', item.day, 'End time raw:', item.end_time, 'Converted:', convert24to12(item.end_time));
  console.log('Day:', item.day, 'Srtat time raw:', item.start_time, 'Converted:', convert24to12(item.start_time));

  return (
    <Grid key={item.day} container alignItems="center" sx={{ mb: 1 }}>
      <Grid item xs={2}>
        <Text variant="body2">{item.day}</Text>
      </Grid>
      <Grid item xs={3}>
        <FormControl fullWidth size="small">
          <Select
            id={`${item.day}-open-time`}
            value={convert24to12(item.start_time) || ""}
            onChange={(event) => handleOpenTimeChange(index, event)}
            disabled={item.closed}
            sx={selectStyles}
            MenuProps={menuProps}
          >
            {timeIntervals.map((time) => (
              <MenuItem key={time} value={time}>
                {time}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={3}>
        <FormControl fullWidth size="small">
        <Select
  id={`${item.day}-close-time`}
  value={convert24to12(item.end_time)}
  onChange={(event) => handleCloseTimeChange(index, event)}
  disabled={item.closed || !item.start_time}
  sx={selectStyles}
  MenuProps={menuProps}
>
  {timeIntervals
    .filter((time) => compareTimes(time, convert24to12(item.start_time) || ""))
    .map((time) => (
      <MenuItem key={time} value={time}>
        {time}
      </MenuItem>
    ))}
</Select>
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Switch color="primary" checked={!item.status} onChange={() => handleToggleCloseDay(index)} />
        </Box>
      </Grid>
    </Grid>
  );
})}


      <Box sx={{ mt: 3 }}>
        <FormControl fullWidth>
          <Select
            id="timeZone"
            value={timeZone || ""}
            onChange={handleTimeZone}
            displayEmpty
            fullWidth
            open={dropdownOpen}
            onOpen={() => setDropdownOpen(true)}
            onClose={() => setDropdownOpen(false)}
            sx={selectStyles}
            MenuProps={{
              ...menuProps,
              PaperProps: {
                ...menuProps.PaperProps,
                sx: {
                  ...menuProps.PaperProps.sx,
                  padding: 1,
                }
              }
            }}
            renderValue={(selected) => {
              if (!selected) {
                return <em>Select Timezone</em>;
              }
              return selected;
            }}
          >
            <Box sx={{ p: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search timezone..."
                value={searchQuery}
                onChange={handleSearchChange}
                sx={{
                  backgroundColor: "#041A29",
                  borderRadius: "4px",
                  "& .MuiInputBase-input": {
                    color: "white",
                    padding: "8px 12px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#FFC857",
                  },
                  mb: 1,
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#FFC857" }} />
                    </InputAdornment>
                  ),
                }}
                onClick={(e) => e.stopPropagation()}
              />
            </Box>
            {availableTimeZones.length === 0 ? (
              <MenuItem disabled>No timezones found</MenuItem>
            ) : (
              availableTimeZones.map((tz) => (
                <MenuItem key={tz} value={tz}>
                  {tz}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ mt: 3, textAlign: "left" }}>
        <Button
          variant="contained"
          onClick={saveConfig}
          sx={{
            backgroundColor: "#FFC857",
            fontWeight: "700",
            color: "black",
            "&:hover": {
              backgroundColor: "#FFC857",
              color: "black",
            },
          }}
        >
          Save
        </Button>
      </Box>

      <Toast
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        handleClose={handleToastClose}
      />
    </Box>
    </>
  )
}

export default TimingScreen